import React, { useEffect, useState } from 'react';

import {
    Container as MaterialContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import * as customColumnsSelectors from 'common/modules/customColumns/selectors';

import * as contactsActions from '../contacts/actions';
import * as contactsSelectors from '../contacts/selectors';

import * as actions from './actions';
import ListItems from './components/ListItems';
import { getPastDate } from './helpers';
import * as selectors from './selectors';

const Container = ({
    fetchUsers,
    filterProposals,
    isFetching,
    isFetchingTableSettings,
    paginationItems,
    proposals,
    tableSettings,
    users,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        createdBy: 'all',
        isArchived: 'False',
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        startDate: getPastDate(30),
        status: 'all',
    });
    useEffect(() => {
        filterProposals(filterData);
        fetchUsers();
    }, []);
    return (
        <MaterialContainer maxWidth={false} sx={{ mb: 2 }}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('Proposal', { count: 2 })} />
                </Grid>
            </HeaderContainer>
            <ListItems
                filterData={filterData}
                filterItems={filterProposals}
                isFetching={isFetching || isFetchingTableSettings}
                items={proposals}
                paginationData={paginationItems}
                setFilterData={setFilterData}
                tableSettings={tableSettings}
                users={users}
            />
        </MaterialContainer>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetching: selectors.getIsFetchingProposals,
    isFetchingTableSettings: customColumnsSelectors.getIsFetchingTableSettings,
    paginationItems: selectors.getProposalsPagination,
    proposals: selectors.getProposalsData,
    tableSettings: customColumnsSelectors.getTableSettingsData,
    users: contactsSelectors.getUsersData,
});

const mapDispatchToProps = (dispatch) => ({
    filterProposals: (filterData) =>
        dispatch(actions.filterProposals(filterData)),
    fetchUsers: () => dispatch(contactsActions.fetchUsers()),
});

Container.propTypes = {
    fetchUsers: PropTypes.func,
    filterProposals: PropTypes.func,
    isFetching: PropTypes.bool,
    isFetchingTableSettings: PropTypes.bool,
    paginationItems: PropTypes.object,
    proposals: PropTypes.array,
    tableSettings: PropTypes.array,
    users: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
